import React from 'react';
import { useAppSelector } from '../../hooks/redux';

const ReputationChart: React.FC = () => {
  const { score, level, breakdown } = useAppSelector((state) => state.reputation);

  const levelColors: Record<string, string> = {
    citizen: 'bg-[var(--color-neutral-200)]',
    advocate: 'bg-[var(--color-brand-200)]',
    champion: 'bg-[var(--color-brand-300)]',
    leader: 'bg-[var(--color-warning-200)]',
  };

  const maxScore = 5000; // Maximum score for visualization
  const percentage = Math.min(100, (score / maxScore) * 100);

  return (
    <div className="bg-[var(--color-default-background)] p-6 rounded-lg shadow-sm">
      <h3 className="text-lg font-semibold mb-4 text-[var(--color-default-font)]">Reputation Progress</h3>
      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-2xl font-bold text-[var(--color-default-font)]">{score}</span>
          <span className={`px-3 py-1 rounded-full text-sm font-medium ${levelColors[level] || 'bg-[var(--color-neutral-200)]'}`}>
            {level}
          </span>
        </div>
        <div className="w-full bg-[var(--color-neutral-200)] rounded-full h-3">
          <div
            className="bg-[var(--color-brand-primary)] h-3 rounded-full transition-all"
            style={{ width: `${percentage}%` }}
            role="progressbar"
            aria-valuenow={score}
            aria-valuemin={0}
            aria-valuemax={maxScore}
          />
        </div>
      </div>
      {breakdown && Object.keys(breakdown).length > 0 && (
        <div className="space-y-2">
          <h4 className="text-sm font-medium text-[var(--color-default-font)]">Breakdown</h4>
          {Object.entries(breakdown).map(([key, value]) => (
            <div key={key} className="flex justify-between text-sm">
              <span className="text-[var(--color-subtext-color)] capitalize">{key.replace('_', ' ')}</span>
              <span className="font-medium text-[var(--color-default-font)]">{value as number}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ReputationChart;

